import { ValidatorRules } from '../../../../util/validator'
import { StrategyStepState } from '../strategy-slice'

export const leverageVolControlRules: ValidatorRules<StrategyStepState> = {
  leverage_volControl_protectionAsset: [
    (state: StrategyStepState) => ({
      isValid: !!state.selectedStrategy.leverage.volControl.protectionAsset
    })
  ]
}
